import { render, staticRenderFns } from "./InstantSearchPagination.vue?vue&type=template&id=43c44150&scoped=true&"
import script from "./InstantSearchPagination.vue?vue&type=script&lang=js&"
export * from "./InstantSearchPagination.vue?vue&type=script&lang=js&"
import style0 from "./InstantSearchPagination.vue?vue&type=style&index=0&id=43c44150&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c44150",
  null
  
)

export default component.exports